import { Routes } from '@angular/router';

import { environment } from '../environments/environment';
import { authGuard } from './auth/auth.guard';
import { NeedPermissionGuard } from './auth/need-permission.guard';
import { SignInComponent } from './auth/sign-in/sign-in.component';
import { DashboardComponent } from './home/dashboard/dashboard.component';
import { HomeComponent } from './home/home.component';
import { MaintenanceComponent } from './maintenance/maintenance.component';

export const routes: Routes = [
  { path: 'sign-in', title: 'Galaxy - Sign in', component: SignInComponent },
  {
    path: '',
    pathMatch: 'full',
    title: 'Galaxy',
    canActivate: [authGuard],
    component: DashboardComponent,
  },
  {
    path: 'maintenance',
    title: 'Maintenance',
    component: MaintenanceComponent,
  },
  {
    path: '',
    component: HomeComponent,
    canActivate: [authGuard],
    children: [
      {
        path: 'audios',
        title: environment.routing_title_prefix + 'Audios - Galaxy',
        data: {
          title: 'Audios',
          animation: 0,
          neededPermission: 'GALAXY_READER',
          type: 'audio',
          parentGroup: 'galaxy',
        },
        canActivate: [NeedPermissionGuard],
        loadChildren: () =>
          import('./contents/contents.routes').then(m => m.ContentsRoutes),
      },
      {
        path: 'videos',
        title: environment.routing_title_prefix + 'Videos - Galaxy',
        data: {
          title: 'Videos',
          animation: 1,
          neededPermission: 'GALAXY_READER',
          type: 'video',
          parentGroup: 'galaxy',
        },
        canActivate: [NeedPermissionGuard],
        loadChildren: () =>
          import('./contents/contents.routes').then(m => m.ContentsRoutes),
      },
      {
        path: 'apps',
        title: environment.routing_title_prefix + 'Apps - Galaxy',
        data: {
          title: 'Apps',
          animation: 2,
          neededPermission: 'GALAXY_READER',
          type: 'app',
          parentGroup: 'galaxy',
        },
        canActivate: [NeedPermissionGuard],
        loadChildren: () =>
          import('./contents/contents.routes').then(m => m.ContentsRoutes),
      },
      {
        path: 'images',
        title: environment.routing_title_prefix + 'Images - Galaxy',
        data: {
          title: 'Images',
          animation: 3,
          neededPermission: 'GALAXY_READER',
          type: 'image',
          parentGroup: 'galaxy',
        },
        canActivate: [NeedPermissionGuard],
        loadChildren: () =>
          import('./contents/contents.routes').then(m => m.ContentsRoutes),
      },
      {
        path: 'articles',
        title: environment.routing_title_prefix + 'Articles - Galaxy',
        data: {
          title: 'Articles',
          animation: 4,
          neededPermission: 'GALAXY_READER',
          type: 'article',
          parentGroup: 'galaxy',
        },
        canActivate: [NeedPermissionGuard],
        loadChildren: () =>
          import('./contents/contents.routes').then(m => m.ContentsRoutes),
      },
      {
        path: 'books',
        title: environment.routing_title_prefix + 'Books - Galaxy',
        data: {
          title: 'Books',
          animation: 24,
          neededPermission: 'GALAXY_READER',
          type: 'book',
          parentGroup: 'galaxy',
        },
        canActivate: [NeedPermissionGuard],
        loadChildren: () =>
          import('./contents/contents.routes').then(m => m.ContentsRoutes),
      },
      {
        path: 'contents',
        title: environment.routing_title_prefix + 'Contents - Galaxy',
        data: {
          title: 'Contents',
          animation: 5,
          neededPermission: 'GALAXY_READER',
          type: 'contents',
          parentGroup: 'galaxy',
        },
        canActivate: [NeedPermissionGuard],
        loadChildren: () =>
          import('./contents/contents.routes').then(m => m.ContentsRoutes),
      },
      {
        path: 'carts',
        title: environment.routing_title_prefix + 'Carts - Galaxy',
        data: {
          title: 'Carts',
          animation: 6,
          neededPermission: 'GALAXY_INTEGRATOR',
          parentGroup: 'galaxy',
        },
        canActivate: [NeedPermissionGuard],
        loadChildren: () =>
          import('./carts/carts.routes').then(m => m.CartsRoutes),
      },
      {
        path: 'campaigns',
        title: environment.routing_title_prefix + 'Campaigns - Fusio',
        data: {
          title: 'Campaigns',
          animation: 7,
          neededPermission: 'FUSIO_READER',
          parentGroup: 'fusio',
        },
        canActivate: [NeedPermissionGuard],
        loadChildren: () =>
          import('./campaign/campaign.routes').then(m => m.CampaignRoutes),
      },
      {
        path: 'multi-campaigns-management',
        title:
          environment.routing_title_prefix +
          'Multi campaigns management - Fusio',
        data: {
          title: 'Multi campaigns management',
          animation: 22,
          neededPermission: 'FUSIO_READER',
          parentGroup: 'fusio',
        },
        canActivate: [NeedPermissionGuard],
        loadChildren: () =>
          import(
            './rubric/multi-campaigns-management/multi-campaigns-management.routes'
          ).then(m => m.MultiCampaignsManagementRoutes),
      },
      {
        path: 'search-engine-configs',
        title:
          environment.routing_title_prefix +
          'Search Engine Configuration - Fusio',
        data: {
          title: 'Search Engine Configuration',
          animation: 8,
          neededPermission: 'TELESCOPE_ACCESS',
          parentGroup: 'fusio',
        },
        canActivate: [NeedPermissionGuard],
        loadChildren: () =>
          import('./search-engine/search-engine.routes').then(
            m => m.SearchEngineRoutes
          ),
      },
      {
        path: 'rules',
        title: environment.routing_title_prefix + 'Rules - Fusio',
        data: {
          title: 'Rules',
          animation: 9,
          neededPermission: 'FUSIO_RULE',
          parentGroup: 'admin',
        },
        canActivate: [NeedPermissionGuard],
        loadChildren: () =>
          import('./rule/rule.routes').then(m => m.RuleRoutes),
      },
      {
        path: 'providers',
        title: environment.routing_title_prefix + 'Providers - Galaxy',
        data: {
          title: 'Providers',
          animation: 10,
          neededPermission: 'GALAXY_ADMIN_PROVIDER',
          parentGroup: 'admin',
        },
        canActivate: [NeedPermissionGuard],
        loadChildren: () =>
          import('./provider/provider.routes').then(m => m.ProviderRoutes),
      },
      {
        path: 'series',
        title: environment.routing_title_prefix + 'Series - Galaxy',
        data: {
          title: 'Series',
          animation: 11,
          neededPermission: 'GALAXY_READER',
          type: 'series',
          parentGroup: 'galaxy',
        },
        canActivate: [NeedPermissionGuard],
        loadChildren: () =>
          import('./serie/serie.routes').then(m => m.SeriesRoutes),
      },
      {
        path: 'channels',
        title: environment.routing_title_prefix + 'Live TV - Galaxy',
        data: {
          title: 'Live TV',
          animation: 12,
          neededPermission: 'GALAXY_ADMIN_LIVE_TV',
          type: 'live',
          parentGroup: 'galaxy',
        },
        canActivate: [NeedPermissionGuard],
        loadChildren: () =>
          import('./tvchannels/tvchannels.routes').then(
            m => m.TvChannelsRoutes
          ),
      },
      {
        path: 'music',
        title: environment.routing_title_prefix + 'Music - Galaxy',
        data: {
          title: 'Music',
          animation: 13,
          neededPermission: 'GALAXY_READER',
          type: 'albums',
          parentGroup: 'galaxy',
        },
        canActivate: [NeedPermissionGuard],
        loadChildren: () =>
          import('./albums/albums.routes').then(m => m.AlbumsRoutes),
      },
      {
        path: 'publications',
        title: environment.routing_title_prefix + 'Publications - Galaxy',
        data: {
          title: 'Publications',
          animation: 25,
          neededPermission: 'GALAXY_READER',
          type: 'publications',
          parentGroup: 'galaxy',
        },
        canActivate: [NeedPermissionGuard],
        loadChildren: () =>
          import('./publications/publications.routes').then(
            m => m.PublicationRoutes
          ),
      },
      {
        path: 'instant-games',
        title: environment.routing_title_prefix + 'Instant Games - Galaxy',
        data: {
          title: 'Instant Games',
          animation: 26,
          neededPermission: 'GALAXY_ADMIN, GALAXY_ADMIN_INSTANT_GAME',
          type: 'ig',
          parentGroup: 'galaxy',
        },
        canActivate: [NeedPermissionGuard],
        loadChildren: () =>
          import('./instant-games/instant-games.routes').then(
            m => m.InstantGamesRoutes
          ),
      },
      {
        path: 'quizzes',
        title: environment.routing_title_prefix + 'Quizzes - Galaxy',
        data: {
          title: 'Quizzes',
          animation: 27,
          neededPermission: 'GALAXY_ADMIN, GALAXY_ADMIN_QUIZ',
          type: 'quiz',
          parentGroup: 'galaxy',
        },
        canActivate: [NeedPermissionGuard],
        loadChildren: () =>
          import('./quizzes/quizzes.routes').then(m => m.QuizzesRoutes),
      },
      // {
      //   path: 'quiz-questions',
      //   title: environment.routing_title_prefix + 'Question Library - Galaxy',
      //   data: {
      //     title: 'Question Library',
      //     animation: 28,
      //     neededPermission: 'GALAXY_ADMIN',
      //     type: 'quiz-questions',
      //     parentGroup: 'galaxy',
      //   },
      //   canActivate: [NeedPermissionGuard],
      //   loadChildren: () =>
      //     import('./quizzes/quiz-questions/quiz-questions.routes').then(
      //       m => m.QuizQuestionsRoutes
      //     ),
      // },
      {
        path: 'themes',
        title: environment.routing_title_prefix + 'Themes - Galaxy',
        data: {
          title: 'Themes',
          animation: 14,
          neededPermission: 'GALAXY_ADMIN_THEME',
          parentGroup: 'admin',
        },
        canActivate: [NeedPermissionGuard],
        loadChildren: () =>
          import('./theme/theme.routes').then(m => m.ThemeRoutes),
      },
      {
        path: 'import-audio-products',
        title:
          environment.routing_title_prefix + 'Import audio products - Galaxy',
        data: {
          title: 'Import Audio Products',
          animation: 15,
          neededPermission: 'GALAXY_ADMIN_IMPORT_AUDIO',
          parentGroup: 'media imports',
        },
        canActivate: [NeedPermissionGuard],
        loadChildren: () =>
          import('./import-audio-product/import-audio-product.routes').then(
            m => m.ImportAudioProductRoutes
          ),
      },
      {
        path: 'import-videos',
        title: environment.routing_title_prefix + 'Import Videos - Explorer',
        data: {
          title: 'Media Explorer',
          animation: 16,
          neededPermission: 'GALAXY_ADMIN_IMPORT_VIDEO',
        },
        canActivate: [NeedPermissionGuard],
        loadChildren: () =>
          import(
            './smart-video/smart-video-explorer/smart-video-explorer.routes'
          ).then(m => m.SmartVideoExplorerRoutes),
      },
      {
        path: 'encode-videos',
        title: environment.routing_title_prefix + 'Import Videos - Encoder',
        data: {
          title: 'Video Encoder',
          animation: 17,
          neededPermission: 'GALAXY_ADMIN_IMPORT_VIDEO',
        },
        canActivate: [NeedPermissionGuard],
        loadChildren: () =>
          import('./smart-video/video-encoder/video-encoder.routes').then(
            x => x.VideoEncoderRoutes
          ),
      },
      {
        path: 'queue-videos',
        title: environment.routing_title_prefix + 'Import Videos - Queues',
        data: {
          title: 'Encoding Queues',
          animation: 18,
          neededPermission: 'GALAXY_ADMIN_IMPORT_VIDEO',
        },
        canActivate: [NeedPermissionGuard],
        loadChildren: () =>
          import('./smart-video/video-queues/video-queues.routes').then(
            m => m.VideoQueuesRoutes
          ),
      },
      {
        path: 'process-list',
        title: environment.routing_title_prefix + 'Media processes',
        data: {
          title: 'Media processes',
          animation: 81,
          neededPermission: 'GALAXY_READER',
        },
        canActivate: [NeedPermissionGuard],
        loadChildren: () =>
          import('./media-processes/media-processes.routes').then(
            m => m.MediaProcessesRoutes
          ),
      },
      {
        path: 'media-processes',
        redirectTo: 'process-list',
        pathMatch: 'full',
      },
      {
        path: 'media-processes/:category',
        redirectTo: 'process-list/:category',
      },
      {
        path: 'artists',
        title: environment.routing_title_prefix + 'Artists - Galaxy',
        data: {
          title: 'Artists',
          animation: 19,
          neededPermission: 'GALAXY_READER',
          parentGroup: 'admin',
        },
        canActivate: [NeedPermissionGuard],
        loadChildren: () =>
          import('./artist/artist.routes').then(m => m.ArtistRoutes),
      },
      {
        path: 'history',
        title: 'History - Galaxy',
        data: {
          title: 'History',
          animation: 20,
          neededPermission: 'GALAXY_READER',
        },
        canActivate: [NeedPermissionGuard],
        loadChildren: () =>
          import('./history/history.module').then(m => m.HistoryModule),
      },
      {
        path: 'documentation',
        title: environment.routing_title_prefix + 'Documentation - Galaxy',
        data: {
          title: 'Documentation',
          animation: 21,
          neededPermission: 'GALAXY_READER',
        },
        canActivate: [NeedPermissionGuard],
        loadChildren: () =>
          import('./documentation/documentation.module').then(
            m => m.DocumentationModule
          ),
      },
      {
        path: 'hidden',
        title: environment.routing_title_prefix + 'Hidden - Galaxy',
        data: {
          title: 'Hidden',
          animation: 22,
          neededPermission: 'GALAXY_READER',
        },
        canActivate: [NeedPermissionGuard],
        loadChildren: () =>
          import('./hidden/hidden.module').then(m => m.HiddenModule),
      },
      {
        path: 'import-flows',
        title: environment.routing_title_prefix + 'Import flows',
        data: {
          title: 'Import flows',
          animation: 23,
          neededPermission: 'GALAXY_IMPORT_FLOW',
        },
        canActivate: [NeedPermissionGuard],
        loadChildren: () =>
          import('./import-flow/import-flow.module').then(
            m => m.ImportFlowModule
          ),
      },
      {
        path: 'rights-map',
        title: environment.routing_title_prefix + 'Rights Map',
        data: {
          title: 'Rights Map',
          animation: 28,
          neededPermission: 'GALAXY_ADMIN',
          parentGroup: 'admin',
        },
        canActivate: [NeedPermissionGuard],
        loadComponent: () =>
          import('./rights-map/rights-map.component').then(
            m => m.RightsMapComponent
          ),
      },
    ],
  },
  { path: '**', redirectTo: '' },
];
